<template>
  <v-container fluid class="px-0">
    <div class="employee-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="user-card ma-1" min-height="282">
            <v-card-text class="pa-5 pt-9 fill-height">
              <v-row no-gutters class="fill-height">
                <v-col
                  cols="12"
                  md="2"
                  class="d-flex justify-center align-center flex-column"
                >
                  <div class="avatar-wrapper">
                    <v-img
                      class="user-avatar"
                      contain
                      v-bind:src="initvalue.employeeimage"
                    ></v-img>
                  </div>
                  <v-chip small class="mr-2 mt-4 mb-4 mb-sm-0" color="primary">
                    {{ initvalue.employeestatus }}</v-chip
                  >
                </v-col>
                <v-col>
                  <v-row>
                    <p class="user-name greyMedium--text font-weight-regular">
                      {{ initvalue.employeename }}
                    </p>
                    <v-spacer></v-spacer>
                    <v-btn @click="$router.replace({ name: 'EmployeeList' })" color="primary" text>
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <p class="user-work ma-0"><b>EMPLOYEE</b></p>
                      <p class="two-line">{{ initvalue.employeename }}</p>
                      <p class="two-line">{{ initvalue.employeeaddress }}</p>
                      <p class="two-line">{{ initvalue.employeephone }}</p>
                      <p class="two-line">{{ initvalue.employeemobile }}</p>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <p class="user-work ma-0"><b>BIRTHDATE</b></p>
                      <p class="two-line">
                        {{
                          initvalue.employeebirthdate != undefined
                            ? new Date(initvalue.employeebirthdate).toLocaleString(
                                "en-SG",
                                {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                }
                              )
                            : ""
                        }}
                      </p>
                      <p style="margin-bottom: 5px"></p>
                      <p class="user-work ma-0"><b>START</b></p>
                      <p class="two-line">
                        {{
                          initvalue.employeestartdate != undefined
                            ? new Date(initvalue.employeestartdate).toLocaleString(
                                "en-SG",
                                {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                }
                              )
                            : ""
                        }}
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      class="
                        pl-0 pl-sm-4
                        d-flex
                        flex-column
                        align-center align-sm-start
                      "
                    >
                      <p class="user-work ma-0"><b>AMOUNT</b></p>
                      <p class="two-line">
                        {{
                          initvalue.employeetotal != undefined
                            ? initvalue.employeetotal.toLocaleString("en-SG")
                            : ""
                        }}
                      </p>
                      <p class="two-line">{{ initvalue.employeepayterms }}</p>
                      <p style="margin-bottom: 5px"></p>
                      <p class="user-work ma-0"><b>NOTE</b></p>
                      <p class="two-line">{{ initvalue.employeenote }}</p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>
                    <v-tab-item :value="'tab-files'" :key="2">
                      <FileView :id="initvalue._id" :route="`employee`" :files="files" :data="initvalue"/>
                    </v-tab-item>  
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import FileView from "@/pages/File/Components/FileView.vue";

export default {
  name: "Profile",
  components: {
    FileView
  },
  data() {
    return {
      initvalue: {},
      transactions: [],
      files: [],
    };
  },
  methods: {

  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "EmployeeList" });
    console.log(this.initvalue)
    this.files = this.initvalue.files;
    console.log('111', this.files)
  },
};
</script>

<style src="./View.scss" lang="scss"/>
